export default "__VITE_ASSET__Cyw_ssGc__"